import { render, staticRenderFns } from "./org-member-profiles.vue?vue&type=template&id=719729a1&scoped=true&"
import script from "./org-member-profiles.vue?vue&type=script&lang=js&"
export * from "./org-member-profiles.vue?vue&type=script&lang=js&"
import style0 from "./org-member-profiles.vue?vue&type=style&index=0&id=719729a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719729a1",
  null
  
)

export default component.exports